import { ActivityFilterKey, FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { ActivityList as ActivityListBase } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';

export type ActivitiesProps = {
  assetId?: string;
  onIssueSelected?: (id: string) => void;
  showAssetName?: boolean;
  selectedIssue?: string;
  onActivityCountChange?: (count: number) => void;
  onDataLoaded?: (data: any) => void;
  hideFilterBar?: boolean;
};

export const ActivityList = (props: ActivitiesProps) => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);

  const filterKey = props.assetId
    ? ActivityFilterKey.AssetActivity
    : ActivityFilterKey.Activity;

  return (
    <View style={styles.container}>
      <ActivityListBase
        showScrollIndicator={true}
        containerStyle={styles.container}
        filterKey={filterKey}
        showTopBar={!isCropCircleEnabled}
        {...props}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    overflow: 'hidden',
    borderRadius: 0,
    flex: 1
  },
});
